export class SageHrIntegration {
  constructor(
    public organizationId: string,
    public enabled: boolean,
    public apiKeyConfigured: boolean,
    public apiUrl: string | null,
    public lastSyncedAt: Date | null
  ) {}
}
